import { ExclusiveBanner } from '../components/ExclusiveBanner';
import { useExclusiveBannerService } from '../services/useExclusiveBannerService';

export const ExclusiveBannerContainer = () => {
  const { ref, vertical_page_banner, handleClick } = useExclusiveBannerService();

  if (!vertical_page_banner) {
    return null;
  }

  return (
    <ExclusiveBanner
      ref={ref}
      image_url={vertical_page_banner.image_url ?? ''}
      title={vertical_page_banner.title?.text ?? ''}
      description={vertical_page_banner.content?.text ?? ''}
      onClick={handleClick}
    />
  );
};
